var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ts4qrvqe5b",
    x1: "20.259%",
    x2: "90.952%",
    y1: "12.586%",
    y2: "80.756%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EC6B29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FCB116"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "s9ad901xia",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.000000, -502.000000) translate(30.000000, 502.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c5n3dfw0hc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s9ad901xia"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "url(#ts4qrvqe5b)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c5n3dfw0hc)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.928932, 4.928932)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.071,
    cy: 7.071,
    r: 6.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.351 0.955H7.851V13.955H6.351z",
    transform: "translate(7.101398, 7.454951) rotate(-45.000000) translate(-7.101398, -7.454951)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.071,
    cy: 7.071,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 2.25,
    ry: 6.25,
    transform: "translate(7.071068, 7.071068) rotate(-315.000000) translate(-7.071068, -7.071068)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.13459fe99ccafb72f594d243f453d799.svg";
export { ForwardRef as ReactComponent };